<template>
  <b-modal
    id="upload-image-show-modal"
    ref="bookmarkModal"
    :hide-header="true"
    :hide-footer="true"
    :no-close-on-backdrop="true"
  >
    <b-overlay :show="overlayShow" rounded="sm">
      <div>
        <b-button
          @click="hideModal()"
          aria-label="Close"
          class="close"
          v-if="attendeeType === this.consts.attendeeType.florist"
        >
          <b-icon-x font-scale="2"></b-icon-x>
        </b-button>
      </div>

      <div
        class="d-flex align-items-center justify-content-center flex-nowrap px-2 mb-3"
        v-if="attendeeType === consts.attendeeType.florist"
      >
        <div class="flex-grow-1 d-flex justify-content-center">
          <p class="h4 mb-0">ブックマーク一覧</p>
        </div>

        <div class="d-flex align-items-center flex-shrink-0" style="gap: 0.5rem;">
          <div class="d-flex align-items-center">
            <div class="estimate-show-indicator"></div>
            <span class="ml-2 estimate-show-text text-nowrap">見積に表示中</span>
          </div>

          <div v-if="imageData !== null && imageData.length">
            <b-button
              variant="primary"
              class="text-nowrap"
              @click="saveEstimateShow()"
              :disabled="loginStatus['referenceFlag'] === '1'"
            >
              保存
            </b-button>
          </div>
        </div>
      </div>

      <div class="text-center mb-3" v-else>
        <p class="h4">ブックマーク一覧</p>
      </div>

      <div class="col-sm-12 overflow-auto p-0">
        <div v-if="imageData !== null && imageData.length">
          <div
            class="card-deck py-3 w-100 customer-img-col-cnt m-0"
            v-for="(uploadImages, index) in imageData"
            :key="index"
          >
            <div
              class="card position-relative border-0 bg-unset card-sqr-gray card-h-250px mb-5"
              v-for="(uploadImage, i) in uploadImages"
              :key="'imageCard' + i"
            >
              <div
                class="mt-2 mr-2 mb-2 ml-1 position-absolute"
                style="z-index:1"
                v-if="attendeeType === consts.attendeeType.florist"
              >
                <label
                  class="form-check-label labex-box-white py-1 px-2 my-1 ml-1"
                  :for="'delete' + index + '-' + i"
                  style="font-size: 1rem"
                >
                  <input
                    type="checkbox"
                    class="checkbox-scale-larger mt-2"
                    :id="'delete' + index + '-' + i"
                    v-model="uploadImage.delete"
                  >
                  削除
                </label>

                <label
                  class="form-check-label labex-box-white py-1 px-2 my-1 ml-2"
                  style="font-size: 1rem"
                  :for="'isEstimateShow' + index + '-' + i"
                >
                  <input
                    type="checkbox"
                    class="checkbox-scale-larger mt-2"
                    :id="'isEstimateShow' + index + '-' + i"
                    true-value="表示する"
                    false-value=""
                    v-model="uploadImage.isEstimateShow"
                    @change="handleEstimateShowChange(uploadImage)"
                  >
                  見積に表示
                </label>
              </div>

              <div class="p-0 upload-image h-100">
                <img
                  :src="uploadImage.image"
                  class="h-100 ar-3-2"
                  :class="{
                    'estimate-show-border':
                      attendeeType === consts.attendeeType.florist &&
                      uploadImage.originIsEstimateShow === '表示する'
                  }"
                >

                <div class="row" v-if="attendeeType === consts.attendeeType.florist">
                  <div class="col-1 pl-0 pr-0">
                    <span
                      class="border border-dark rounded-circle btn p-1 mt-1 ml-2"
                      @click="movePage(uploadImage.name, 'ブックマーク')"
                    >
                      <b-icon-vector-pen scale="1"></b-icon-vector-pen>
                    </span>
                  </div>

                  <div class="col-3 ps-0 pr-0 text-right">
                    <b-button
                      class="mt-1"
                      variant="primary"
                      @click="goToProductSelectionFromBookmark(
                        uploadImage.productProjectNumber,
                        changeToProjectType(uploadImage.productCategory),
                        changeToSuggestionType(uploadImage.productCategory)
                      )"
                      :disabled="loginStatus['referenceFlag'] === '1'"
                    >
                      提案
                    </b-button>
                  </div>

                  <!-- 右側：カテゴリ + 並び順 + エラー -->
                  <div class="col d-flex justify-content-end pe-0">
                    <div class="controls-stack">
                      <div class="controls-row">
                        <!-- カテゴリ -->
                        <div
                          :ref="`categoryWrapper-${index}-${i}`"
                          class="mr-2 position-relative custom-category-wrapper"
                          style="font-size: 1rem"
                          v-click-outside="() => closeCategoryDropdown(index, i)"
                        >
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-secondary dropdown-toggle custom-category-btn"
                            @click="toggleCategoryDropdown(index, i)"
                          >
                            <span class="custom-category-text">
                              {{ getCategoryDisplayText(uploadImage.categories) }}
                            </span>
                          </button>

                          <div
                            v-show="categoryDropdownOpen[`${index}-${i}`]"
                            :class="getDropdownClasses(index, i)"
                            class="dropdown-menu show"
                            @mousedown.prevent
                          >
                            <div
                              v-for="category in categoryOptions"
                              :key="category.value"
                              class="dropdown-item p-0"
                            >
                              <label class="d-flex align-items-center w-100 px-3 py-2 mb-0" style="cursor: pointer;">
                                <input
                                  type="checkbox"
                                  class="mr-2"
                                  :checked="isCategorySelected(uploadImage.categories, category.value)"
                                  @change="toggleCategory(uploadImage, category.value)"
                                  style="cursor: pointer;"
                                >
                                <span>{{ category.text }}</span>
                              </label>
                            </div>

                            <div class="dropdown-divider"></div>
                            <div class="dropdown-item p-0">
                              <button
                                type="button"
                                class="btn btn-sm btn-link w-100 text-left text-muted"
                                @click="clearCategories(uploadImage)"
                              >
                                すべてクリア
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- 並び順 -->
                        <label
                          class="form-check-label labex-box-white py-1 px-2 my-1 ml-2 d-flex align-items-center sort-order-label"
                          style="font-size: 1rem; height: 38px;"
                        >
                          <span class="mr-1">並び順</span>
                          <input
                            type="text"
                            class="form-control sort-order-input"
                            :class="{ 'sort-order-invalid': uploadImage.sortOrderError }"
                            v-model="uploadImage.sortOrderDisplay"
                            @input="handleSortOrderInput(uploadImage, $event)"
                            @blur="handleSortOrderBlur(uploadImage)"
                            maxlength="2"
                          >
                        </label>
                      </div>

                      <div class="controls-error-row">
                        <div v-if="uploadImage.sortOrderError" class="sort-order-error">
                          {{ uploadImage.sortOrderErrorMessage }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <template v-if="uploadImages.length < imageRowMaxNum">
              <div
                class="card position-relative border-0 bg-unset"
                v-for="i in (imageRowMaxNum - uploadImages.length)"
                :key="'emptyCard' + i"
              >
                <div class="p-0"></div>
              </div>
            </template>
          </div>
        </div>

        <div v-else>
          <p class="mt-5 text-center">画像がありません</p>
        </div>
      </div>
    </b-overlay>

    <CommonModal ref="commonModal" @confirmOk="saveEstimateShowSend" />
  </b-modal>
</template>

<script>
import CommonModal from '@/components/CommonModal'
import BookmarkImageListModel from '@/models/BookmarkImageListModel'
import BookmarkImageEstimateShowModel from '@/models/BookmarkImageEstimateShowModel'
import CookieInfoModel from '@/models/CookieInfoModel'

export default {
  name: 'BookmarkModal',
  components: { CommonModal },
  directives: {
    clickOutside: {
      bind (el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    }
  },
  data () {
    return {
      overlayShow: false,
      attendeeType: '',
      imageRowMaxNum: 3,
      imageData: {},
      loginStatus: '',
      bookmarkImageData: { bookmarkImages: [] },
      categoryOptions: [
        { value: 'スペック', text: 'スペック' },
        { value: 'メイン', text: 'メイン' },
        { value: 'ゲスト', text: 'ゲスト' },
        { value: 'メインオプション', text: 'メインオプション' },
        { value: 'ゲストオプション', text: 'ゲストオプション' },
        { value: 'コーディネート', text: 'コーディネート' },
        { value: '演出', text: '演出' },
        { value: 'その他', text: 'その他' },
        { value: '贈呈', text: '贈呈' },
        { value: '挙式', text: '挙式' },
        { value: 'ブーケ', text: 'ブーケ' },
        { value: 'エターナルブーケ', text: 'エターナルブーケ' }
      ],
      categoryDropdownOpen: {}
    }
  },
  props: {
    cookieProjectNumber: {
      type: String,
      default: ''
    }
  },
  methods: {
    showModal (attendeeType) {
      this.attendeeType = attendeeType
      this.setApiData()
      this.$refs.bookmarkModal.show()
      if (this.attendeeType === this.consts.attendeeType.florist) {
        this.$emit('signalingModalChangeEvent', 'modalBookmarkImageShow')
      }
    },
    hideModal () {
      this.$refs.bookmarkModal.hide()
      if (this.attendeeType === this.consts.attendeeType.florist) {
        this.$emit('signalingModalChangeEvent', 'modalBookmarkListHide')
      }
    },

    // ===== 並び順：全角→半角変換 =====
    toHalfWidthNumber (str) {
      if (str == null) return ''
      return String(str).replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
    },

    // ===== 並び順：検証＆正規化（保存押下時に使う）=====
    validateAndNormalizeSortOrder (image) {
      let v = (image.sortOrderDisplay || '').trim()
      v = this.toHalfWidthNumber(v)
      if (v.length > 2) v = v.slice(0, 2)
      image.sortOrderDisplay = v

      // 空欄OK（未設定）
      if (v === '') {
        image.sortOrder = null
        image.sortOrderError = false
        image.sortOrderErrorMessage = ''
        return true
      }

      // 半角数字のみ
      if (!/^[0-9]+$/.test(v)) {
        image.sortOrder = null
        image.sortOrderError = true
        image.sortOrderErrorMessage = '「並び順」には数字を入力してください'
        return false
      }

      const num = parseInt(v, 10)
      if (num < 1 || num > 99) {
        image.sortOrder = null
        image.sortOrderError = true
        image.sortOrderErrorMessage = '並び順は1〜99で入力してください'
        return false
      }

      image.sortOrder = num
      image.sortOrderError = false
      image.sortOrderErrorMessage = ''
      return true
    },

    validateSortOrdersBeforeSave () {
      let firstErr = null
      let firstMsg = ''
      this.imageData.forEach((row, rIdx) => {
        row.forEach((img, cIdx) => {
          const r = this.validateAndNormalizeSortOrder(img)
          if (!r && !firstErr) {
            firstErr = { rIdx, cIdx }
            firstMsg = '入力に誤りがあります。赤色で表示されている項目を修正してください。'
          }
        })
      })
      if (firstErr) {
        return { ok: false, message: firstMsg }
      }
      return { ok: true, message: '' }
    },

    uploadImageData () {
      const store = this.bookmarkImageData
      if (!store) return null

      const normalizedImages = store.bookmarkImages.map(img => {
        // categories
        const categories = (!img.estimateDisplayCategory || img.estimateDisplayCategory === '')
          ? []
          : img.estimateDisplayCategory.split(',').map(c => c.trim()).filter(c => c !== '')

        // sortOrder / sortOrderDisplay
        let sortOrder = null
        let sortOrderDisplay = ''
        if (img.sortOrder !== null && img.sortOrder !== undefined && Number(img.sortOrder) > 0) {
          sortOrder = Number(img.sortOrder)
          sortOrderDisplay = sortOrder === 99 ? '' : String(sortOrder)
        }

        return {
          ...img,
          originIsEstimateShow: img.isEstimateShow,
          delete: false,
          categories,
          sortOrder,
          sortOrderDisplay,
          sortOrderError: false,
          sortOrderErrorMessage: ''
        }
      })

      const length = Math.ceil(normalizedImages.length / this.imageRowMaxNum)
      this.imageData = new Array(length).fill().map((_, i) =>
        normalizedImages.slice(i * this.imageRowMaxNum, (i + 1) * this.imageRowMaxNum)
      )

      this.bookmarkImageData.bookmarkImages = []
    },

    async setApiData () {
      this.overlayShow = true
      let startFlag = true
      let result = ''
      let sumImageNum = 0
      let params = { startNo: 0 }

      while (startFlag) {
        result = await BookmarkImageListModel.apiSetStore(this.$bvModal, params, () => {})
        sumImageNum += result.ImageNum
        params.startNo += result.ImageNum

        for (let i in result.bookmarkImages) {
          this.bookmarkImageData.bookmarkImages.push(result.bookmarkImages[i])
        }

        if (sumImageNum === result.totalImageNum) startFlag = false
      }

      this.uploadImageData()
      this.loginStatus = JSON.parse(localStorage.getItem('loginStatus'))
      this.overlayShow = false
    },

    async movePage (fileName, projectType) {
      const ok = await this.cookieProjectNumberCheck()
      if (!ok) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      fileName = fileName.split('.')[0]
      this.hideModal()
      this.$emit('goToProductSelection', fileName, projectType)
    },

    async saveEstimateShow () {
      const ok = await this.cookieProjectNumberCheck()
      if (!ok) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }

      const v = this.validateSortOrdersBeforeSave()
      if (!v.ok) {
        this.$refs.commonModal.msgBoxOk(v.message)
        return
      }

      let hasDelete = false
      this.imageData.forEach(images => {
        images.forEach(image => {
          if (image.delete === true) hasDelete = true
        })
      })

      if (hasDelete) {
        this.$refs.commonModal.msgBoxConfirm('「削除」にチェックした画像を削除します。よろしいですか？')
      } else {
        this.saveEstimateShowSend()
      }
    },

    async saveEstimateShowSend () {
      const v = this.validateSortOrdersBeforeSave()
      if (!v.ok) {
        this.overlayShow = false
        this.$refs.commonModal.msgBoxOk(v.message)
        return
      }

      this.overlayShow = true
      const params = []

      this.imageData.forEach(images => {
        images.forEach(image => {
          const categoryString = (image.categories && image.categories.length > 0)
            ? image.categories.join(',')
            : ''

          let sortOrderValue = null
          if (image.sortOrder !== null && image.sortOrder !== undefined) {
            sortOrderValue = Number(image.sortOrder)
          }

          params.push({
            fileName: image.name,
            isEstimateShow: image.isEstimateShow,
            delete: !!image.delete,
            category: categoryString,
            sortOrder: sortOrderValue
          })
        })
      })

      await BookmarkImageEstimateShowModel.apiSetStore(this.$bvModal, params, (response) => {
        this.imageData.forEach(images => {
          images.forEach(image => {
            image.originIsEstimateShow = image.isEstimateShow
          })
        })

        this.overlayShow = false
        this.$emit('signalingModalChangeEvent', 'modalBookmarkImageReload')
      })

      await this.setApiData()
    },

    async cookieProjectNumberCheck () {
      let params = ['projectNumber']
      const current = await CookieInfoModel.apiSetStore(this.$bvModal, params, () => {})
      return current.cookieInfo === this.cookieProjectNumber
    },

    closeCategoryDropdown (rowIndex, colIndex) {
      const key = `${rowIndex}-${colIndex}`
      this.$set(this.categoryDropdownOpen, key, false)
    },
    toggleCategoryDropdown (rowIndex, colIndex) {
      const key = `${rowIndex}-${colIndex}`
      Object.keys(this.categoryDropdownOpen).forEach(k => {
        if (k !== key) this.$set(this.categoryDropdownOpen, k, false)
      })
      this.$set(this.categoryDropdownOpen, key, !this.categoryDropdownOpen[key])
    },
    getDropdownClasses () {
      return 'category-dropdown-menu category-dropdown-menu-top'
    },
    getCategoryDisplayText (categories) {
      if (!categories || categories.length === 0) return ''
      if (categories.length === 1) return categories[0]
      return `${categories[0]} 他${categories.length - 1}件`
    },
    isCategorySelected (categories, value) {
      return categories && categories.includes(value)
    },
    clearCategories (image) {
      image.categories = []
      this.$forceUpdate()
    },
    toggleCategory (image, categoryValue) {
      if (!image.categories) image.categories = []
      const index = image.categories.indexOf(categoryValue)
      if (index > -1) image.categories.splice(index, 1)
      else image.categories.push(categoryValue)
      this.$forceUpdate()
    },

    // チェック変更時にバリデーションはしない（保存押下時のみ）
    handleEstimateShowChange () {},

    changeToProjectType (productCategory) {
      if (['スペック提案', 'メイン提案', 'ゲスト提案', 'メインオプション', 'ゲストオプション'].includes(productCategory)) {
        return 'メインテーブル・ゲストテーブル'
      }
      return productCategory
    },
    changeToSuggestionType (productCategory) {
      if (productCategory === 'スペック提案') return 'cordinate'
      if (productCategory === 'メイン提案') return 'main'
      if (productCategory === 'ゲスト提案') return 'guest'
      if (productCategory === 'メインオプション') return 'mainopt'
      if (productCategory === 'ゲストオプション') return 'guestopt'
      return ''
    },
    async goToProductSelectionFromBookmark (projectNumber, projectType, suggestionType) {
      const ok = await this.cookieProjectNumberCheck()
      if (!ok) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      this.hideModal()
      this.$emit('goToProductSelectionFromBookmark', projectNumber, projectType, suggestionType)
    },

    // 入力中は消さない（2文字制限のみ）。エラーは保存押下で。
    handleSortOrderInput (changedImage, event) {
      let value = event.target.value
      if (value.length > 2) value = value.slice(0, 2)
      changedImage.sortOrderDisplay = value
      changedImage.sortOrderError = false
      changedImage.sortOrderErrorMessage = ''
    },

    // blurで全角→半角のみ（エラー判定しない）
    handleSortOrderBlur (changedImage) {
      let v = (changedImage.sortOrderDisplay || '').trim()
      v = this.toHalfWidthNumber(v)
      if (v.length > 2) v = v.slice(0, 2)
      changedImage.sortOrderDisplay = v
    }
  }
}
</script>

<style scoped>
.upload-image {
  position: relative;
}

.estimate-show-border {
  border: 3px solid #28a745 !important;
  box-shadow: 0 0 8px rgba(40, 167, 69, 0.4) !important;
}

.estimate-show-indicator {
  width: 35px;
  height: 24px;
  border: 3px solid #28a745;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(40, 167, 69, 0.35);
  background-color: #ffffff;
  flex-shrink: 0;
}

.custom-category-btn {
  padding: 0.5rem 0.75rem !important;
  font-size: 1rem !important;
  line-height: 1.5 !important;
  height: 38px !important;
  min-width: 80px !important;
  max-width: 80px !important;
  display: inline-flex !important;
  align-items: center !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  text-align: left !important;
  border-radius: 0.25rem !important;
}

.custom-category-text {
  display: inline-block !important;
  max-width: 48px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.custom-category-wrapper {
  margin-top: 3px !important;
  margin-right: 3px !important;
}

.sort-order-input {
  width: 40px !important;
  height: 28px !important;
  padding: 0.25rem 0.5rem !important;
  font-size: 1rem !important;
  line-height: 1.5 !important;
  border-radius: 0.25rem !important;
  text-align: center !important;
}

.sort-order-label {
  position: relative !important;
  top: 2px !important;
  width: fit-content;
}

.category-dropdown-menu {
  position: absolute;
  left: 0;
  z-index: 1000;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  min-width: 220px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

.category-dropdown-menu-top {
  bottom: 100%;
  margin-bottom: 0.25rem;
  top: auto !important;
}

.category-dropdown-menu .dropdown-item:hover {
  background-color: #f8f9fa;
}

.category-dropdown-menu label:hover {
  background-color: #f8f9fa;
}

/* ===== 並び順エラー表示（アップロード画像と同じ） ===== */
.sort-order-invalid {
  border: 2px solid #dc3545 !important;
  background-color: #fff5f5 !important;
}

.sort-order-invalid:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.controls-stack {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.controls-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 45px;
}

.controls-error-row {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  min-height: 1.2em;
}

.sort-order-error {
  margin-top: 2px;
  font-size: 0.70rem;
  color: #dc3545;
  line-height: 1.2;
  text-align: right;
  white-space: nowrap;
  max-width: none;
}
</style>



// WEBPACK FOOTER //
// src/components/BookmarkModal.vue